module.exports = __webpack_public_path__ + "img/12.d8177e42.jpg";